import { defineStore } from 'pinia'


/**
 * @title 用于给组合选项卡状态存储
 */

export const useCombinationPageStore = defineStore('combinationPage', {
    state: () => ({
        pageData: {}
    }),
    getters: {
     
    },
    actions: {
        setPageData(id, index, flag) {
            if(!this.pageData[id]) {
                this.pageData[id] = []
            }
            this.pageData[id][index] = flag
        }
    }
})